import React, { useState } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import PageShell from '../../shared/components/PageShell';

const videos = [
    {
        title: 'Bienvenida al taller de capacitación de vigilancia genómica de bacterias multirresistentes',
        desc: 'Description for the first training capsule',
        videoId: 'TKsBZk645S8'
    },
    {
        title: 'Detección de bacterias multirresistentes y extracción de DNA ￼',
        desc: 'Description for the second training capsule',
        videoId: 'b3DXD2SETYU'
    },
    {
        title: 'Preparación de bibliotecas de secuenciación ￼',
        desc: 'Description for the third training capsule',
        videoId: 'hSJH3mk69rE'
    },
    {
        title: 'Análisis bioinformático de genomas bacterianos ￼',
        desc: 'Description for the fourth training capsule',
        videoId: 'eVsB79x9gy4'
    }
];

export default function TrainingVideos() {
    return (
        <Box sx={{ width: '100%' }}>
            <PageShell>
                <Typography variant="h4">
                    Training Videos
                </Typography>
            </PageShell>

            <PageShell pb="100px">
                <Grid
                    container
                    spacing={{ xs: 4, md: 4 }}
                    sx={{
                        width: '100%',
                        justifyContent: 'center'
                    }}
                >
                    {videos.map((video) => (
                        <Grid
                            key={video.videoId}
                            size={{ xs: 12, sm: 10, md: 6, lg: 3 }}
                        >
                            <Box
                                sx={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'center'
                                }}
                            >
                                <VideoCard
                                    title={video.title}
                                    desc={video.desc}
                                    videoId={video.videoId}
                                />
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </PageShell>
        </Box>
    );
}

const VideoCard = ({ title, desc, videoId }) => {
    const [autoplay, setAutoplay] = useState(false);

    const handleCardClick = () => {
        setAutoplay(true);
    };

    return (
        <Box
            onClick={handleCardClick}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                maxWidth: '580px',
                minHeight: '390px',
                height: '100%',
                borderRadius: 4,
                border: '1px solid #000',
                bgcolor: '#fff',
                p: '16px',
                transition: 'background-color .3s ease, border-color .3s ease',
                cursor: 'pointer',

                '&:hover': {
                    bgcolor: '#20BC71',
                    borderColor: '#20BC71',
                },
            }}
        >
            <YouTubePlayer videoId={videoId} title={title} autoplay={autoplay} />

            <Box
                sx={{
                    width: '100%',
                    px: 1,
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >
                <Box sx={{ mb: 1 }}>
                    <Typography variant="h6">
                        {title}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

const YouTubePlayer = ({ videoId, title, autoplay }) => {
    return (
        <Box
            sx={{
                width: '100%',
                aspectRatio: '16/9',
                bgcolor: '#000',
                borderRadius: 2,
                overflow: 'hidden',
                mb: 3,
                flexShrink: 0,
            }}
        >
            <iframe
                width="100%"
                height="100%"
                src={`https://www.youtube.com/embed/${videoId}${autoplay ? '?autoplay=1' : ''}`}
                title={title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{
                    border: 0,
                    display: 'block'
                }}
            />
        </Box>
    );
};